module.exports = __webpack_public_path__ + "images/emoji/yen.d5c30d66e147ae3c57d6.png";